import { Injectable } from '@angular/core';
import { getShellWindow } from '@element451-libs/models451';
import {
  IPgSocialFeedItem,
  SerializablePage451Component,
  SocialNetwork
} from '@element451-libs/page451-lib';
import {
  BILLBOARD_APP_ACTIONS,
  EditorRowsProxy,
  tokensConfig
} from '@element451-libs/page451-rows';
import { truthy } from '@element451-libs/utils451/rxjs';
import { TokensService } from '@element451-libs/utils451/tokens';
import { find, uniqueId } from 'lodash';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MediaService } from '../+state/media';
import { AccountService, SiteService, StartApplication } from '../../+state';

@Injectable()
export class RowsProxyService extends EditorRowsProxy {
  /**
   * Core
   */
  selectComponent(id: string) {
    return this.site.components$.pipe(
      truthy,
      map(components => find(components, c => c.pageGuid === id))
    );
  }

  transform(
    row: SerializablePage451Component
  ): Observable<SerializablePage451Component> {
    return this.tokens
      .replaceToken(row, tokensConfig)
      .pipe(map(r => ({ ...r, _changeId: uniqueId() as any })));
  }

  /**
   * Social data
   */
  selectSocialNetworks(): Observable<SocialNetwork[]> {
    return this.site.socialMediaNetworks$;
  }

  selectSocialFeedPosts(): Observable<IPgSocialFeedItem[]> {
    return null;
    //     return this.feeds.feeds$.pipe(map(socialFeedPostsToSocialFeedItems));
  }

  loadMoreFeeds() {
    //     this.feeds.loadMore();
  }

  selectIsSubmitting(formGuid: string) {
    return of(false);
  }

  paymentDone(formGuid: string): void {}

  action(type, payload) {
    switch (type) {
      case BILLBOARD_APP_ACTIONS.SIGN_IN:
        this.accountService.openSignInDialogAction();
        break;

      case BILLBOARD_APP_ACTIONS.START_APPLICATION:
        this.startApplication.openStartApplicationDialog();
        break;
    }
  }

  /**
   * Media Handling
   */
  playVideo(url: string) {
    this.mediaService.playVideo(url);
  }

  openImage(url: string) {
    this.mediaService.openImage(url);
  }

  startThread(message: string) {
    const shellWindow = getShellWindow();

    if (shellWindow.Shell451?.BoltDiscovery && message.length) {
      shellWindow.Shell451.BoltDiscovery.ask(message);
    }
  }

  constructor(
    private mediaService: MediaService,
    private tokens: TokensService,
    private accountService: AccountService,
    private startApplication: StartApplication,
    private site: SiteService
  ) {
    super();
  }
}

export function getComponentGuidByFormGuid(
  entities: Observable<any>,
  formGuid: string,
  componentTypes: string[] = ['prepopulated-left', 'prepopulated-centered']
): string {
  let row = null;
  entities.forEach((rows: any) => {
    row = find(
      rows,
      (r: any) =>
        componentTypes.includes(r.type) && r.form && r.form.guid === formGuid
    );
  });
  return row ? row.pageGuid : null;
}
